import { createAction } from 'redux-actions'

const prefix = 'NAVIGATION/'

export const navigate = createAction(`${prefix}NAVIGATE`)
export const backToLogin = createAction(`${prefix}BACK_TO_LOGIN`)
export const back = createAction(`${prefix}BACK`)
export const navigateToProfileMonitoring = createAction(`${prefix}NAVIGATE_TO_PROFILE_MONITORING`)
export const redirectAuthenticated = createAction(`${prefix}REDIRECT_AUTHENTICATED`)
